// extracted by mini-css-extract-plugin
export default {"control":"setor-select_control__No38k","label":"setor-select_label__Zgd8G","icon":"setor-select_icon__pXYs1"};